export const navRoutes = [
  // { label: 'home', route: '/home' },
  { label: 'threads', route: '/threads' },
  { label: 'thread', route: '/thread/1' },
  { label: 'channels', route: '/channels' },
  // { label: 'channels/anon', route: '/channel/anonymous' }
  // { label: 'pagination example', route: '/blog?page=1' },
]
